// extracted by mini-css-extract-plugin
export default {"container":"HomeContainer_container__X4ouP"};